export { default } from './DeleteModal';
